/**
 * Overlay listing the journal entries behind one GL account, opened from the Balance Sheet /
 * Cash Flow magnifier so the statement stays on screen. Same list (and entry-detail popup) as
 * Reconciliation › Journal Entries; "Open full page" keeps the old navigation available.
 */
import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton, Typography } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import JournalEntriesList from './reconciliation/JournalEntriesList';

export default function AccountEntriesDialog({ drill, onClose }) {
  if (!drill) return null;
  const qs = new URLSearchParams({ tab: 'journal-entries', account_code: drill.accountCode });
  if (drill.startDate) qs.set('start_date', drill.startDate);
  if (drill.endDate) qs.set('end_date', drill.endDate);
  const period = drill.startDate ? `${drill.startDate} → ${drill.endDate}` : `to ${drill.endDate}`;
  return (
    <Dialog open onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ pr: 6 }}>
        {drill.accountCode}{drill.accountName ? ` — ${drill.accountName}` : ''}
        <Typography variant="body2" color="text.secondary">Journal entries {period}</Typography>
        <IconButton onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }} aria-label="Close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <JournalEntriesList key={`${drill.accountCode}-${drill.startDate}-${drill.endDate}`} drill={drill} />
      </DialogContent>
      <DialogActions>
        <Button href={`/finance/journal-reconciliation?${qs.toString()}`} target="_blank" rel="noopener">Open full page</Button>
        <Button onClick={onClose} variant="contained">Close</Button>
      </DialogActions>
    </Dialog>
  );
}
